module.exports = __webpack_public_path__ + "static/media/image_47.ea1b78d3.png";